// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Header_navbar__1orYE","logo":"Header_logo__B59QK"};